<template>
    <div class="radio-list">
        <label class="radio">
            <input type="radio" name="multi" :checked="!value" @click="$emit('input', false)">
            <span></span>Eine Marke
        </label>
        <label class="radio">
            <input type="radio" name="multi" :checked="value" @click="$emit('input', true)">
            <span></span>Mehrere Marken
        </label>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            types: [Boolean, Object],
        },
    },
}
</script>
